import { Popover } from 'antd'
import type { TooltipPlacement } from 'antd/es/tooltip'
import Picker, { type EmojiClickData, Theme } from 'emoji-picker-react'
import { useState } from 'react'
import type { ReactNode } from 'react'

import { useThemeMode } from 'src/theme'

import { useStyles } from './styles'

export type EmojiPickerProps = {
  onSelect: (emoji: string) => void
  children: ReactNode
  placement?: TooltipPlacement
  width?: number
  height?: number
}

export const EmojiPicker = ({
  onSelect,
  children,
  placement = 'topLeft',
  width = 340,
  height = 360
}: EmojiPickerProps) => {
  const { styles } = useStyles()
  const { mode } = useThemeMode()
  const [open, setOpen] = useState(false)

  const onEmojiClick = (emoji: EmojiClickData) => {
    onSelect(emoji.emoji)
    setOpen(false)
  }

  return (
    <Popover
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement={placement}
      classNames={{ content: styles.popoverContent }}
      content={
        <div
          className={styles.picker}
          onMouseDown={(event) => event.stopPropagation()}
        >
          <Picker
            onEmojiClick={onEmojiClick}
            width={width}
            height={height}
            previewConfig={{ showPreview: false }}
            theme={mode === 'dark' ? Theme.DARK : Theme.LIGHT}
            autoFocusSearch
            skinTonesDisabled
            lazyLoadEmojis
          />
        </div>
      }
    >
      <span
        className={styles.trigger}
        onMouseDown={(event) => event.stopPropagation()}
      >
        {children}
      </span>
    </Popover>
  )
}
